export default "__VITE_ASSET__DjIE7Pwd__"